// Placeholder legal content for Paranormal Archetypes.
// The owner will replace the body text with final approved policy copy.
// Each entry renders on the in-app Legal screen.

export const LEGAL_LAST_UPDATED = 'June 2026'; // TODO: set to the official launch month/year
export const LEGAL_CONTACT_EMAIL = 'Info@ParanormalArchetypes.net';

export const LEGAL_DOCS = [
  {
    key: 'privacy',
    title: 'Privacy Policy',
    icon: 'lock',
    body: `The privacy of your information is important to us. This Privacy Policy explains what information Paranormal Archetypes collects, how it is used, and the choices you have regarding your information.

1. Information We Collect
When you create an account or use Paranormal Archetypes, we may collect information including:
- Your name
- Your email address
- Your assessment responses
- Your assessment results
- Products you purchase or unlock
- Access code redemption history
- Notes and information you choose to save within the app

We collect only the information necessary to provide and improve the Paranormal Archetypes experience.

2. How We Use Your Information
Your information is used to:
- Create and manage your account
- Deliver purchased products and content
- Save your assessment results
- Restore your purchases and entitlements
- Improve the functionality and reliability of the platform
- Respond to customer support requests

We do not sell your personal information.

3. Assessment Results
Your assessment responses and results are stored so your Paranormal Archetypes profile can remain available across future visits and devices associated with your account.

Your assessment results are intended for your personal use within the Paranormal Archetypes platform.

4. Account Security
We take reasonable measures to help protect the information stored within Paranormal Archetypes.

While no online service can guarantee absolute security, we work to protect your information using appropriate technical and administrative safeguards.

5. Third Party Services
Paranormal Archetypes may rely on trusted third party services to support account authentication, payment processing, email delivery, and application hosting.

These providers receive only the information necessary to perform their services and maintain their own privacy and security practices.

6. Your Choices
You may update certain account information at any time.

You may also request deletion of your account. Deleting your account permanently removes your account information and associated data as described within the application.

7. Children's Privacy
Paranormal Archetypes is not intended for children under the age of 13, and we do not knowingly collect personal information from children under 13.

If we become aware that such information has been collected, we will take reasonable steps to remove it.

8. Changes to This Privacy Policy
This Privacy Policy may be updated from time to time to reflect changes to the platform, applicable laws, or business practices.

When significant changes are made, the updated version will be posted within the application.

9. Contact Us
If you have questions about this Privacy Policy or your information, please contact@ParanormalArchetypes.net`,
  },
  {
    key: 'terms',
    title: 'Terms of Service',
    icon: 'file-text',
    body: `By accessing or using Paranormal Archetypes, you agree to these Terms of Service. If you do not agree with these Terms, please do not use the platform.

1. Acceptance of These Terms
These Terms govern your use of the Paranormal Archetypes website, mobile application, assessment, educational materials, and related products and services.

By creating an account, redeeming an access code, purchasing a product, or using the platform, you agree to these Terms.

2. Eligibility and Accounts
You are responsible for maintaining the accuracy of your account information and for safeguarding access to your account.

You are responsible for all activity that occurs under your account.

3. Purchases and Digital Content
All purchases are subject to the published pricing at the time of purchase.

Unless otherwise stated, purchases provide a license for your personal use only and may not be copied, redistributed, resold, or shared without written permission.

Please refer to our No Refund Policy for information regarding digital purchases.

4. Assessment and Educational Materials
The Paranormal Archetypes assessment, Manual, Starter Kit, Guidebook, and related materials are educational resources designed to encourage observation, reflection, discussion, and continued learning.

They are not intended to provide scientific proof, professional advice, diagnoses, or guarantees of any outcome.

5. Intellectual Property
All Paranormal Archetypes content, including the assessment, scoring methodology, archetypes, written materials, graphics, logos, trademarks, product names, and related intellectual property remain the property of Paranormal Archetypes unless otherwise stated.

No portion may be reproduced, distributed, modified, or used commercially without prior written permission.

6. Acceptable Use
You agree not to:
- Attempt to gain unauthorized access to the platform.
- Share or distribute purchased content without permission.
- Misrepresent your identity or use another person's account.
- Use the platform in a manner that violates applicable laws.

7. Account Termination
Paranormal Archetypes reserves the right to suspend or terminate accounts that violate these Terms or misuse the platform.

Users may also choose to delete their accounts through the application.

8. Disclaimer of Warranties
Paranormal Archetypes is provided on an "as is" and "as available" basis.

While we strive to provide a reliable experience, we do not guarantee uninterrupted availability or that the platform will always be free of errors.

9. Limitation of Liability
To the fullest extent permitted by law, Paranormal Archetypes shall not be liable for indirect, incidental, consequential, or special damages arising from the use of the platform, assessment, products, or related materials.

10. Changes to These Terms
These Terms may be updated from time to time.

Continued use of Paranormal Archetypes after updates are posted constitutes acceptance of the revised Terms.

11. Contact Us
Questions regarding these Terms of Service may be directed to@ParanormalArchetypes.net`,
  },
  {
    key: 'disclaimer',
    title: 'Disclaimer',
    icon: 'alert-triangle',
    body: `The Paranormal Archetypes assessment, products, and educational materials are intended for education, self reflection, personal exploration, and entertainment.

Paranormal Archetypes is a research based framework designed to help individuals recognize patterns in how they observe, process, and interact with paranormal experiences. It is intended to encourage observation, reflection, discussion, and continued learning.

The results of the assessment are not presented as absolute conclusions, scientific proof, psychological diagnoses, personality classifications, or professional advice. No assessment can fully define an individual or predict future experiences.

Each person's experiences, beliefs, interpretations, and conclusions remain their own. The information provided through Paranormal Archetypes should be considered one tool among many for personal exploration and team discussion.

The paranormal remains an area of ongoing exploration and debate. Paranormal Archetypes does not claim to explain every experience or provide definitive answers regarding paranormal phenomena.

Nothing contained within the assessment, Manual, Starter Kit, Guidebook, website, mobile application, presentations, videos, social media content, or any related materials should be interpreted as medical, psychological, legal, financial, or other professional advice.

Users are responsible for their own decisions, actions, interpretations, investigations, and conclusions.

By using Paranormal Archetypes, you acknowledge that you understand and accept these limitations and agree to use the framework as an educational resource for recognizing patterns through observation, reflection, and experience.`,
  },
  {
    key: 'refund',
    title: 'No Refund Policy',
    icon: 'refresh-ccw',
    body: `All sales are final. We do not offer refunds, returns, or exchanges on any purchase.

1. All Sales Are Final
- Paranormal Archetypes products are digital, and access is granted immediately upon purchase or access-code redemption. Because of this, all sales are final and non-refundable.

2. No Refunds
- We do not provide refunds, returns, credits, or exchanges for any product, including the Quiz, Starter Kit, Guidebook, Manual, or Complete Bundle.

3. Access Issues
- If you experience a technical problem accessing content you have purchased, contact us at ${'Info@ParanormalArchetypes.net'} and we will help restore your access. Assistance with access does not constitute a refund.

4. Questions Before You Buy
- If you have any questions about a product before purchasing, please reach out to ${'Info@ParanormalArchetypes.net'} and we will be glad to help.

By completing a purchase, you acknowledge and agree to this No Refund Policy.`,
  },
];
